import { create } from "zustand";

interface MetricPoint {
  timestamp: number;
  value: number;
}

interface MetricsStore {
  costTimeline: MetricPoint[];
  tokenInputTimeline: MetricPoint[];
  tokenOutputTimeline: MetricPoint[];
  runCompletions: MetricPoint[];
  maxPoints: number;

  addCostPoint: (costUsd: number) => void;
  addTokenPoint: (input: number, output: number) => void;
  addRunCompletion: (success: boolean) => void;
  clear: () => void;
}

export const useMetricsStore = create<MetricsStore>((set) => ({
  costTimeline: [],
  tokenInputTimeline: [],
  tokenOutputTimeline: [],
  runCompletions: [],
  maxPoints: 200,

  addCostPoint: (costUsd) =>
    set((s) => {
      const point = { timestamp: Date.now(), value: costUsd };
      const timeline = [...s.costTimeline, point];
      if (timeline.length > s.maxPoints) timeline.splice(0, timeline.length - s.maxPoints);
      return { costTimeline: timeline };
    }),

  addTokenPoint: (input, output) =>
    set((s) => {
      const now = Date.now();
      const inputTimeline = [...s.tokenInputTimeline, { timestamp: now, value: input }];
      const outputTimeline = [...s.tokenOutputTimeline, { timestamp: now, value: output }];
      if (inputTimeline.length > s.maxPoints) inputTimeline.splice(0, inputTimeline.length - s.maxPoints);
      if (outputTimeline.length > s.maxPoints) outputTimeline.splice(0, outputTimeline.length - s.maxPoints);
      return { tokenInputTimeline: inputTimeline, tokenOutputTimeline: outputTimeline };
    }),

  addRunCompletion: (success) =>
    set((s) => {
      const point = { timestamp: Date.now(), value: success ? 1 : 0 };
      const completions = [...s.runCompletions, point];
      if (completions.length > s.maxPoints) completions.splice(0, completions.length - s.maxPoints);
      return { runCompletions: completions };
    }),

  clear: () => set({ costTimeline: [], tokenInputTimeline: [], tokenOutputTimeline: [], runCompletions: [] }),
}));
